/* Wabrings display currency switcher.
   Default = the store's own Shopify currency (native money formatting, untouched).
   Switching to another currency converts the DISPLAY only (checkout still charges the store currency). */
(function(){
  'use strict';
  var STORE = window.WabStoreCurrency || 'AED';
  var DEFAULT = 'AUD';  /* currency shown on first visit — display only; checkout charges the store currency */
  // multipliers relative to AED (the store's base currency)
  var RATES  = { AED: 1, AUD: 1/2.6, USD: 0.2723, GBP: 0.2136, EUR: 0.2513 };
  var SYMBOL = { AED: 'AED ', AUD: 'A$', USD: '$', GBP: '£', EUR: '€' };
  if (!RATES[STORE]) { RATES[STORE] = 1; SYMBOL[STORE] = STORE + ' '; }

  function get(){ try { return localStorage.getItem('wab_cur') || DEFAULT; } catch(e){ return DEFAULT; } }
  function save(c){ try { localStorage.setItem('wab_cur', c); } catch(e){} }

  function convert(cents, cur){
    var v = (Number(cents)/100) * (RATES[cur] / RATES[STORE]);
    var s = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (SYMBOL[cur] || (cur + ' ')) + s;
  }

  function apply(cur){
    if (!RATES[cur]) cur = STORE;
    window.WabCurrency = cur;
    window.WabStore = STORE;
    window.WabRate = RATES[cur] / RATES[STORE];
    window.WabSymbol = SYMBOL[cur];
    var els = document.querySelectorAll('[data-cents]');
    for (var i=0;i<els.length;i++){
      var el = els[i];
      if (el.getAttribute('data-native') === null) el.setAttribute('data-native', el.textContent);
      el.textContent = (cur === STORE) ? el.getAttribute('data-native')
                                       : convert(el.getAttribute('data-cents'), cur);
    }
    var sels = document.querySelectorAll('[data-cur-select]');
    for (var j=0;j<sels.length;j++) sels[j].value = cur;
    if (window.WabringsCart && window.WabringsCart.refresh){ try { window.WabringsCart.refresh(); } catch(e){} }
  }

  document.addEventListener('change', function(e){
    var t = e.target;
    if (t && t.matches && t.matches('[data-cur-select]')){ save(t.value); apply(t.value); }
  });

  window.WabMoney = convert;
  window.WabApplyCurrency = apply;
  apply(get());
})();
